import React from "react";
import FileSaver from "file-saver";
import { UserAddOutlined} from '@ant-design/icons';
class VCardFileCreator extends React.Component {
  //{firstName:user.fullname,lastName:'',
  //title:'Developer',email:user.email,mobile:user.mobile,work:user.bisMobile,location:user.address}
  constructor(props) {
    super(props);
    this.state = {
      firstName: props.employee.fullname,
      lastName: '',
      title: props.employee.job ?props.employee.job : 'Not Set' ,
      email: props.employee.email,
      mobile:props.employee.mobile? props.employee.mobile : 'Not Set',
      bisMobile: props.employee.bisMobile? props.employee.bisMobile : 'Not Set',

      work: 'Not Set',
      location: props.employee.address
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    e.preventDefault();
    var file = new Blob(
      [
        `BEGIN:VCARD
VERSION:3.0
N:${this.state.lastName};${this.state.firstName};;;
FN:${this.state.firstName} ${this.state.lastName}
TITLE:${this.state.title};
EMAIL;type=INTERNET;type=pref:${this.state.email}
TEL;type=MAIN:${this.state.bisMobile}
TEL;type=CELL;type=VOICE;type=pref:${this.state.mobile}

ADR;type=WORK;type=pref:;;;${this.state.location};;;
END:VCARD
`
      ],
      { type: "text/vcard;charset=utf-8" }
    );
    FileSaver.saveAs(
      file,
      `${this.state.firstName}${this.state.lastName}.vcf`,
      true
    );
  }
  render() {
    return (
      <a href="" onClick={this.handleClick} className={this.props.className}
       style={{backgroundColor:'black', padding:'10px 20px 10px 20px', borderRadius:30, color:'white'}}>
<UserAddOutlined style={{fontSize:20,float:'left',marginRight:'5px'}}/>Save Contact
      </a>
    );
  }
}

export default VCardFileCreator;
